import { useSelector } from 'react-redux';
import { Alert } from 'react-bootstrap';

export default function OrgAdminRoute({
  children,
  message = 'This page is only available to organization admins.',
}) {
  const { user } = useSelector((state) => state.auth);
  const isOrgAdmin = Boolean(
    user?.is_organization_admin ?? user?.is_organization_owner
  );

  if (!isOrgAdmin) {
    return (
      <div className="dashboard-page py-4">
        <Alert variant="warning" className="mb-0">
          {message}
        </Alert>
      </div>
    );
  }

  return children;
}
